<!-- buscador-wizard.component.html -->
<div class="wizard-container" *ngIf="!showResult">
  <!-- Navegación del Wizard -->
  <div class="wizard-nav mb-4">
    <ul class="nav nav-pills nav-wizard">
      <li class="nav-item" *ngFor="let step of steps; let i = index">
        <button
          class="nav-link d-flex align-items-center"
          [class.active]="currentStep === i"
          [class.completed]="isStepCompleted(i)"
          (click)="goToStep(i)"
        >
          <span class="step-number">{{ i + 1 }}</span>
          <span class="step-title">{{ step.title }}</span>
        </button>
      </li>
    </ul>
  </div>

  <!-- Contenido del Wizard -->
  <div class="wizard-content" [formGroup]="wizardForm">
    <div class="step-container" *ngIf="steps[currentStep]">
      <div class="card">
        <div class="card-header">
          <h4 class="mb-0">{{ steps[currentStep].question }}</h4>
        </div>
        <div class="card-body">
          <!-- Opciones únicas -->
          <div *ngIf="!steps[currentStep].isMultiple" class="options-container">
            <div
              class="form-check"
              *ngFor="let option of steps[currentStep].options"
            >
              <input
                class="form-check-input"
                type="radio"
                [id]="option.id"
                [formControlName]="'step' + currentStep"
                [value]="option.value"
              />
              <label class="form-check-label" [for]="option.id">
                {{ option.text }}
              </label>
            </div>
          </div>

          <!-- Opciones múltiples -->
          <div *ngIf="steps[currentStep].isMultiple" class="options-container">
            <div
              class="form-check"
              *ngFor="let option of steps[currentStep].options"
            >
              <input
                class="form-check-input"
                type="checkbox"
                [id]="option.id"
                [value]="option.value"
                (change)="onCheckboxChange($event, currentStep)"
              />
              <label class="form-check-label" [for]="option.id">
                {{ option.text }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Navegación entre pasos -->
  <div class="wizard-footer mt-4 d-flex justify-content-between">
    <button
      class="btn btn-secondary"
      *ngIf="currentStep > 0"
      (click)="previousStep()"
    >
      <i class="bi bi-arrow-left"></i> Anterior
    </button>
    <button
      class="btn btn-primary"
      (click)="nextStep()"
      [disabled]="!canProceedToNextStep()"
    >
      {{ isLastStep() ? "Finalizar" : "Siguiente" }}
      <i class="bi bi-arrow-right" *ngIf="!isLastStep()"></i>
    </button>
  </div>
</div>

<div class="row" *ngIf="showResult">
  <div class="col-md-12">
    <div *ngIf="spinner" class="card-body text-xl-center my-xxl-5">
      <div class="my-xxl-5">
        <div class="spinner-border text-primary my-xxl-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="card-body max-ancho">
        <div
          *ngIf="!spinner"
          class="row"
          data-masonry='{"percentPosition ": true }'
        >
          @for (data of especialistasFiltrados; track data.id) { @if
          (data.servicios.length > 0) {
          <div class="col-xs-12 col-sm-6 col-md-4 ng-star-inserted mb-4">
            <div class="card h-100 border-box">
              <div class="image-container">
                <img src="{{ data.foto }} " alt="{{ data.nombre }}" />
              </div>

              <div class="m-3">
                <h5 class="nombre-title"><strong>{{ data.nombre }}</strong></h5>
                <p class="nombre-subtitle"><em>{{ data.perfil.especialidad }}</em></p>

                <!-- Especialidades-->
                <p class="card-text m-1" *ngIf="data.especialidades.length > 0">
                  <i class="dripicons-trophy"></i> Especialidades
                </p>
                <ul>
                  <li *ngFor="let especialidad of data.especialidades">
                    {{ especialidad.tEspecialidad.especialidad }} -
                    {{ especialidad.idPoblacion.descripcion }}
                  </li>
                </ul>

                <app-expandable-text
                  [text]="data.descripcion"
                  [maxLength]="100"
                ></app-expandable-text>

                <p>
                  <a
                    href="javascript: void(0);"
                    (click)="showAgenda(data)"
                    class="btn_alfinal btn btn-primary waves-effect waves-light"
                  >
                    <i
                      class="dripicons-alarm"
                      style="margin-right: 9px; top: 40px; position: sticky"
                    >
                    </i>
                    Agenda tu cita!</a
                  ><br />
                </p>
              </div>
            </div>
          </div>
          } }
        </div>
      </div>
    </div>
  </div>
</div>
